module.exports = __webpack_public_path__ + "img/sis.b333855f.svg";